import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import HomePage from './pages/HomePage';
import CampaignPage from './pages/CampaignPage';
import CheckVoucher from './pages/CheckVoucher';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CustomerProfile from './pages/CustomerProfile';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route element={<App />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/check" element={<CheckVoucher />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/profile" element={<CustomerProfile />} />
          <Route path="/:uuid" element={<CampaignPage />} />
        </Route>
      </Routes>
    </Router>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
